import { FlexComponent } from "typings/flexFramework/FlexComponent";

export class LinkDialogContext {
  dialogHeading: string;
  modules: FlexComponent[];

  constructor(dialogHeading: string, modules: FlexComponent[]) {
    this.dialogHeading = dialogHeading;
    this.modules = modules;
  }
}

export const LinksDialogContext = new LinkDialogContext("", []);
